export default __webpack_public_path__ + "static/media/exclamation-circle.4dbc8aea.svg";